import React from 'react'
import PropTypes from 'prop-types'

import {
  Content,
  CtaContainer,
  Image,
  ImageWrapper,
  Wrapper,
} from './Card.style'

const Cards = ({
  borderColor,
  children,
  className,
  cta,
  image,
  imageAltText,
  imageLink,
  imageLinkComponent,
  imageSize,
  row,
}) => {
  const componentProps = { className, cta, row }
  return (
    <Wrapper {...componentProps} data-key="max-card">
      <ImageWrapper
        as={imageLink ? imageLinkComponent : 'div'}
        href={imageLink || null}
        imageSize={imageSize}
        row={row || null}
        to={imageLink || null}
      >
        {image && (
          <Image
            src={`${image}?w=400&fit=scale`}
            alt={imageAltText || ''}
            role={imageAltText ? 'img' : 'presentation'}
            borderColor={borderColor}
          />
        )}
      </ImageWrapper>

      <Content cta={cta} row={row}>
        {children}
        {cta && <CtaContainer>{cta}</CtaContainer>}
      </Content>
    </Wrapper>
  )
}

Cards.propTypes = {
  /** The content for the body of the card **/
  children: PropTypes.node.isRequired,
  /** url for the card image **/
  image: PropTypes.string,
  /** Descriptive name to appear/read on the card when image is not shown/see **/
  imageAltText: PropTypes.string,
  /** Size for the card image **/
  imageSize: PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
  /** Optional react node that sits at the bottom of the card. Ideal for a call to action **/
  cta: PropTypes.node,
  /** Set the layout of the card to a row instead of a column **/
  row: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.bool,
    PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
  ]),
  /** A flat card that uses for flat listing page **/
  flat: PropTypes.bool,
  /** Calls a function when the image is clicked. Eg use gatsby's navigate to link to another page **/
  onImageClick: PropTypes.func,
  /** image link url **/
  imageLink: PropTypes.string,
  /** optionally pass custom routing component to image, usually a gatsby Link **/
  imageLinkComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** adds bottom border color to the image of the card **/
  borderColor: PropTypes.string,
  /** YouTube ID of video to be embedded in the card */
  youtubeVideoId: PropTypes.string,
}

Cards.defaultProps = {
  cta: undefined,
  row: null,
  flat: false,
  imageLinkComponent: 'a',
}

export default Cards
